export const Button = (props) => {
  const { label="XXXXX", ejecutar, clases } = props;
  return (
    <button
      title={label}
      onClick={() => {
        ejecutar();
      }}
      className={`${clases}`}
    >
      {label}
    </button>
  );
};
